import PendingOutlined from '@mui/icons-material/PendingOutlined';
import Schedule from '@mui/icons-material/Schedule';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import AttachMoneyOutlined from '@mui/icons-material/AttachMoneyOutlined';
import {
	CHIP_TYPE,
	STATIC_ADMIN_SHIPMENT_STATUS,
	STATIC_SHIPPER_SHIPMENT_STATUS,
	TStaticShipmentStatusChipConfig
} from '@types';

/** Not yet wired into AllLoads/FullBookings columns — swap in once the BE Typesense enum field (AP2-1720) ships. */
const adminShipmentStatusChipConfig: Record<STATIC_ADMIN_SHIPMENT_STATUS, TStaticShipmentStatusChipConfig> = {
	[STATIC_ADMIN_SHIPMENT_STATUS.PENDING]: {
		short: 'Unallocated',
		type: CHIP_TYPE.WARN,
		icon: PendingOutlined,
		label: 'Awaiting allocation.'
	},
	[STATIC_ADMIN_SHIPMENT_STATUS.ALLOCATED]: {
		short: 'Allocated',
		type: CHIP_TYPE.INFO,
		icon: PeopleAltOutlined,
		label: 'This shipment is allocated, and has not been started yet.'
	},
	[STATIC_ADMIN_SHIPMENT_STATUS.ONROAD]: {
		short: 'On The Road',
		type: CHIP_TYPE.INFO,
		icon: Schedule,
		label: 'This shipment is on the way.'
	},
	[STATIC_ADMIN_SHIPMENT_STATUS.DELIVERED]: {
		short: 'Delivered',
		type: CHIP_TYPE.SUCCESS,
		icon: LocationOnOutlined,
		label: 'This shipment has been delivered.'
	},
	[STATIC_ADMIN_SHIPMENT_STATUS.CANCELLED]: {
		short: 'Cancelled',
		type: CHIP_TYPE.ERROR,
		icon: CancelOutlined,
		label: 'Shipment was cancelled'
	},
};

const shipperShipmentStatusChipConfig: Record<STATIC_SHIPPER_SHIPMENT_STATUS, TStaticShipmentStatusChipConfig> = {
	[STATIC_SHIPPER_SHIPMENT_STATUS.PENDING]: {
		short: 'Unallocated',
		type: CHIP_TYPE.WARN,
		icon: PendingOutlined,
		label: 'Awaiting allocation.'
	},
	[STATIC_SHIPPER_SHIPMENT_STATUS.ALLOCATED]: {
		short: 'Allocated',
		type: CHIP_TYPE.INFO,
		icon: PeopleAltOutlined,
		label: 'Your shipment is allocated to a driver.'
	},
	[STATIC_SHIPPER_SHIPMENT_STATUS.ONROAD]: {
		short: 'On The Road',
		type: CHIP_TYPE.INFO,
		icon: Schedule,
		label: 'This shipment is on the way.'
	},
	[STATIC_SHIPPER_SHIPMENT_STATUS.DELIVERED]: {
		short: 'Delivered',
		type: CHIP_TYPE.SUCCESS,
		icon: LocationOnOutlined,
		label: 'This shipment has been delivered.'
	},
	[STATIC_SHIPPER_SHIPMENT_STATUS.AWAITING]: {
		short: 'Awaiting',
		type: CHIP_TYPE.WARN,
		icon: PendingOutlined,
		label: 'We are awaiting your payment.'
	},
	[STATIC_SHIPPER_SHIPMENT_STATUS.PAID]: {
		short: 'Paid',
		type: CHIP_TYPE.SUCCESS,
		icon: AttachMoneyOutlined,
		label: 'The shipment is complete and we have received payment, thank you.'
	},
	[STATIC_SHIPPER_SHIPMENT_STATUS.CANCELLED]: {
		short: 'Cancelled',
		type: CHIP_TYPE.ERROR,
		icon: CancelOutlined,
		label: 'Shipment was cancelled'
	},
};

export const getStaticAdminShipmentStatusChipConfig = (status: string): TStaticShipmentStatusChipConfig | null => {
	return adminShipmentStatusChipConfig[status as STATIC_ADMIN_SHIPMENT_STATUS] ?? null;
}

export const getStaticShipperShipmentStatusChipConfig = (status: string): TStaticShipmentStatusChipConfig | null => {
	return shipperShipmentStatusChipConfig[status as STATIC_SHIPPER_SHIPMENT_STATUS] ?? null;
}
